import * as TYPES from '../types';

export const getAllKnowledgeRepositoryAction = () => {
    return {
        type: TYPES.GET_ALL_K_REPO,
    };
};

export const getAllKnowledgeRepositorySuccessAction = (payload) => {
    return {
        type: TYPES.GET_ALL_K_REPO_SUCCESS,
        payload: payload
    };
};